/**
 * 教参模块
 * 谢冉
 * 2020.8.25
 */

import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import AddForm from './page/AddForm';
import AddPaper from './page/AddPaper';
import GuideBooks from './page/GuideBooks';
import SearchData from './page/SearchData';
import SearchPaper from './page/SearchPaper';

console.log('11111');
class App extends React.Component {
  render() {
    // if (window.parent === window) {
    //   return <div>当前页面限校内地址访问</div>;
    // }
    return (
      <Router>
        <div>
          <Route path="/guideBooks" component={GuideBooks} />
          <Route path="/addForm" component={AddForm} />
          <Route path="/addPaper" component={AddPaper} />
          <Route path="/searchData" component={SearchData} />
          <Route path="/searchPaper" component={SearchPaper} />
        </div>
      </Router>
    );
  }
}
export default App;
